import { CAvatar, CCol, CRow } from "@coreui/react";
import React from "react";
const CustomPopup = ({ device, demoAvatar }) => {
  return (
    <CRow>
      <CCol className="py-2 px-3">
        {device.driver && (
          <>
            <div className="d-flex align-items-center">
              <CAvatar
                src={device.driver.avatar ? device.driver.avatar : demoAvatar}
                size="md"
              />
              <div className="ms-2">
                <h6 className="mb-0">
                  {device.driver.firstName} {device.driver.lastName}
                </h6>
                <span className="text-muted">{device.driver.employeeCode}</span>
              </div>
            </div>
            <hr />
          </>
        )}
        <CRow>
          <CCol>
            <h6 className="mb-0">Speed</h6>
            <span className="text-muted">
              {device.currentPosition.speed} km/h
            </span>
          </CCol>
          <CCol>
            <h6 className="mb-0">Heading</h6>
            <span className="text-muted">
              {device.currentPosition.heading}°
            </span>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <h6 className="mb-0">Latitude</h6>
            <span className="text-muted">
              {device.currentPosition.latitude}
            </span>
          </CCol>
          <CCol>
            <h6 className="mb-0">Longitude</h6>
            <span className="text-muted">
              {device.currentPosition.longitude}
            </span>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <h6 className="mb-0">Altitude</h6>
            <span className="text-muted">
              {device.currentPosition.altitude} m
            </span>
          </CCol>
          <CCol>
            <h6 className="mb-0">Satellites</h6>
            <span className="text-muted">
              {device.currentPosition.satellites}
            </span>
          </CCol>
        </CRow>
        <CRow>
          <CCol className="mt-2">
            <h6 className="mb-0">Last Updated</h6>
            <span className="text-muted">{device.lastUpdated}</span>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  );
};

export default CustomPopup;
